@if (isArticle) {
    <sew-headline ws level="4" [innerHTML]="labels.article_name"></sew-headline>
} @else {
    <sew-headline ws level="4" [innerHTML]="labels.author_name"></sew-headline>
}
<sew-input class="input-name" ws>
    <input type="text" [value]="value" (input)="setValue($any($event.target).value)" autocomplete="off" />
</sew-input>
<div class="sew-dialog-button-group">
    <sew-button class="sew-button" ws hierarchy="tertiary">
        <button (click)="onNoClick()">
            {{ labels.cancel }}
        </button>
    </sew-button>
    <sew-button class="sew-button" ws hierarchy="primary" website>
        <button (click)="onYesClick()" [disabled]="value.length === 0">
            {{ labels.confirm }}
        </button>
    </sew-button>
</div>
